import { render, staticRenderFns } from "./UpcomingTasksCard.vue?vue&type=template&id=f805bc76&scoped=true"
import script from "./UpcomingTasksCard.vue?vue&type=script&lang=ts"
export * from "./UpcomingTasksCard.vue?vue&type=script&lang=ts"
import style0 from "./UpcomingTasksCard.vue?vue&type=style&index=0&id=f805bc76&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f805bc76",
  null
  
)

export default component.exports